export default String.raw`
.products-list{
    &__grid-view-product{
        width: 100%;
    }
    &__list-view-product{
        .content-and-quantity-container{
            flex-direction: column;
        }
        .content-container, .quantity-container{
            width: 100%;
        }
        .content-container .content-container__attributes {
            -webkit-line-clamp: 4;
        }

        @media only screen and (max-width: 425px) {
            &:has(.wishlist) .content-and-quantity-container .primary-action-button__icon {
                display: none;
            }

            .content-and-quantity-container .secondary-action-button__text {
                display: none;
            }

            .content-and-quantity-container .primary-action-button,
            .content-and-quantity-container .secondary-action-button {
                padding: 0;
            }
        }
    }
    &__quick-shopping-view-product{
        flex-direction: column;
        .content-container, .prices-container, .quantity-container{
            width: 100%;
        }
        .prices-container{
            margin-top: 10px;
        }
    }

    .quantity-container {
        .primary-buttons {
            .more-options-mobile {
                display: block;
            }
            .wishlist {
                display: none;
            }
        }
        .secondary-buttons {
            display: none;
        }
    }
}
`